<ms-my-bets-scoreboard-players-pair players class="baseball-pariticpant" [vm]="vm"></ms-my-bets-scoreboard-players-pair>
@if (vm.started) {
    <div class="inning-block">
        <div>
            <div class="mybets-scoreboard_stats">
                <div class="mybets-scoreboard_stats-values mybets-scoreboard_stats-values-set">
                    @if (vm.turn.isVisible) {
                        <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-set">
                            <div class="inning" [class.hidden-visibility]="!vm.turn.player1">
                                <vn-icon class="baseball-indicator-icon" name="theme-baseball-indicator" size="12" />
                            </div>
                            <div class="inning" [class.hidden-visibility]="!vm.turn.player2">
                                <vn-icon class="baseball-indicator-icon" name="theme-baseball-indicator" size="12" />
                            </div>
                            <div class="inning" [class.hidden-visibility]=""><i></i></div>
                        </div>
                    }
                    @for (stat of vm.sets.list | slice: 0 : 9; track stat) {
                        <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-set" [ngClass]="stat.statClasses">
                            <div class="inning" [ngClass]="{ highlight: vm.isHighlighedSet($index, 1) }">
                                {{ stat.isEmpty(1) ? '-' : stat.player1 }}
                            </div>
                            <div class="inning" [ngClass]="{ highlight: vm.isHighlighedSet($index, 2) }">
                                {{ stat.isEmpty(2) ? '-' : stat.player2 }}
                            </div>
                            <div class="inning innings-info" [class.highlight]="$index === vm.activeCurrentInning - 1">{{ $index + 1 }}</div>
                        </div>
                    }
                    @if (vm.sets.list[defaultInnings] && vm.sets.list[defaultInnings].player1 !== '-1') {
                        <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-set extra_innings">
                            <div class="inning highlight">{{ getSum(vm.sets.list, teamType.Team01) }}</div>
                            <div class="inning highlight">{{ getSum(vm.sets.list, teamType.Team02) }}</div>
                            <div class="inning innings-info highlight">{{ sitecore.globalMessages.ExtraInnings }}</div>
                        </div>
                    }
                </div>
            </div>
        </div>
        <i class="slide-bar"></i>
        <div>
            <div class="mybets-scoreboard_stats">
                <div class="mybets-scoreboard_stats-values mybets-scoreboard_stats-values-set">
                    <div class="mybets-scoreboard_stats-column mybets-scoreboard_stats-column-set">
                        <div class="inning total-runs">{{ vm.participant1runs }}</div>
                        <div class="inning total-runs">{{ vm.participant2runs }}</div>
                        <div class="inning innings-info highlight">{{ sitecore.globalMessages.Runs }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
